import { NumberStore } from 'ui/base/input';
import { IComputedValue, action, observable } from 'mobx';

export class BandwidthNumberStore {
  @observable.ref
  value: number;

  total: IComputedValue<number>;

  constructor(total: IComputedValue<number>, value: number) {
    this.total = total;
    this.value = value;
  }

  @action.bound
  setValue(value: number) {
    const others = this.total.get() - this.value;
    if (others + value >= 1) {
      this.value = 1 - others;
    } else {
      this.value = value;
    }
  }
}

export class DeviceBandwidthStore {
  upload: NumberStore;
  download: NumberStore;

  constructor(uploadAllocation: number,
              downloadAllocation: number,
              totalUpload: IComputedValue<number>,
              totalDownload: IComputedValue<number>) {
    this.upload = new BandwidthNumberStore(totalUpload, uploadAllocation);
    this.download = new BandwidthNumberStore(totalDownload, downloadAllocation);
  }
}
